export default "__VITE_ASSET__ec51fc92__"